import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { log } from '@deck.gl/core';

var Tile2DHeader = function () {
  function Tile2DHeader(_ref) {
    var x = _ref.x,
        y = _ref.y,
        z = _ref.z,
        onTileLoad = _ref.onTileLoad,
        onTileError = _ref.onTileError;

    _classCallCheck(this, Tile2DHeader);

    this.x = x;
    this.y = y;
    this.z = z;
    this.isVisible = false;
    this.isSelected = false;
    this.parent = null;
    this.children = [];
    this.content = null;
    this._isLoaded = false;
    this._isCancelled = false;
    this.onTileLoad = onTileLoad;
    this.onTileError = onTileError;
  }

  _createClass(Tile2DHeader, [{
    key: "_loadData",
    value: function () {
      var _loadData2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(getTileData, requestScheduler) {
        var x, y, z, bbox, signal, requestToken, tileData, error;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                x = this.x, y = this.y, z = this.z, bbox = this.bbox;
                this._abortController = new AbortController();
                signal = this._abortController.signal;
                _context.next = 5;
                return requestScheduler.scheduleRequest(this, function (tile) {
                  return tile.isSelected ? 1 : -1;
                });

              case 5:
                requestToken = _context.sent;

                if (requestToken) {
                  _context.next = 9;
                  break;
                }

                this._isCancelled = true;
                return _context.abrupt("return");

              case 9:
                if (!this._isCancelled) {
                  _context.next = 12;
                  break;
                }

                requestToken.done();
                return _context.abrupt("return");

              case 12:
                _context.prev = 12;
                _context.next = 15;
                return getTileData({
                  x: x,
                  y: y,
                  z: z,
                  bbox: bbox,
                  signal: signal
                });

              case 15:
                tileData = _context.sent;
                _context.next = 21;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](12);
                error = _context.t0 || true;

              case 21:
                _context.prev = 21;
                requestToken.done();

                if (this._isCancelled && !tileData) {
                  this._isLoaded = false;
                } else {
                  this._isLoaded = true;
                  this._isCancelled = false;
                }

                return _context.finish(21);

              case 25:
                if (this._isLoaded) {
                  _context.next = 27;
                  break;
                }

                return _context.abrupt("return");

              case 27:
                if (error) {
                  this.onTileError(error, this);
                } else {
                  this.content = tileData;
                  this.onTileLoad(this);
                }

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[12, 18, 21, 25]]);
      }));

      function _loadData(_x, _x2) {
        return _loadData2.apply(this, arguments);
      }

      return _loadData;
    }()
  }, {
    key: "loadData",
    value: function loadData(getTileData, requestScheduler) {
      var _this = this;

      if (!getTileData) {
        return;
      }

      this._isCancelled = false;
      this._loader = this._loadData(getTileData, requestScheduler);

      this._loader["finally"](function () {
        _this._loader = undefined;
      });
    }
  }, {
    key: "abort",
    value: function abort() {
      if (this.isLoaded) {
        return;
      }

      this._isCancelled = true;

      this._abortController.abort();
    }
  }, {
    key: "data",
    get: function get() {
      return this._isLoaded ? this.content : this._loader;
    }
  }, {
    key: "isLoaded",
    get: function get() {
      return this._isLoaded;
    }
  }, {
    key: "isLoading",
    get: function get() {
      return Boolean(this._loader);
    }
  }, {
    key: "isCancelled",
    get: function get() {
      return this._isCancelled;
    }
  }, {
    key: "byteLength",
    get: function get() {
      var result = this.content ? this.content.byteLength : 0;

      if (!Number.isFinite(result)) {
        log.error('byteLength not defined in tile data')();
      }

      return result;
    }
  }]);

  return Tile2DHeader;
}();

export { Tile2DHeader as default };
//# sourceMappingURL=tile-2d-header.js.map